import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactSelect from "react-select";

import { useInformations } from "../../hooks/useInformations";
import { useName } from "../../hooks/useName";

import { ISelect, ISelectValue } from "../../interfaces/select";
import { IStatus } from "../../interfaces/status";

import { Informations } from "../Informations";

import { Container, styles } from "./styles";

export const Select: React.FC<ISelect> = (props) => {
  const { name } = useName(props.name);

  const [value, setValue] = useState<ISelectValue>(null);

  const informationsRef = useRef(null);

  const { informations, onValidate, getInformationsClasses } = useInformations({
    ref: informationsRef,
    inputProps: props,
  });

  useEffect(() => {
    setValue(props.value!);
  }, [props.value]);

  const onChange = (value: any) => {
    setValue(value);

    props.onChange && props.onChange(name, value);
  };

  const [status, setStatus] = useState<IStatus>("VALIDATED");

  const validate = useCallback(() => {
    if (props.required && (!value || value === null)) {
      setStatus("ERROR_REQUIRED");
      return;
    }

    setStatus("VALIDATED");
  }, [props.required, value]);

  useEffect(() => {
    validate();
  }, [validate]);

  return (
    <Container
      className={`select-container ${getInformationsClasses()}`}
      {...{ name, "data-status": status, "data-input": "select" }}
      onBlurCapture={onValidate}
    >
      <ReactSelect
        {...{
          styles: {
            ...styles,
            menuList: (provided) => ({
              ...provided,
              maxHeight: props.menuMaxHeight || "14rem",
              overflowY: "auto",
              zIndex: 1000000,
            }),
          },
          name,
          value,
          onChange,
          isSearchable: props.searchable !== false,
          options: props.options,
          placeholder: props?.placeholder || "",
          noOptionsMessage: () => "Sem opções",
          isDisabled: props.disabled,
          isMulti: props.multiple,
        }}
      />
      <Informations {...{ name, ref: informationsRef, ...informations }} />
    </Container>
  );
};
